import { useParams } from "react-router-dom";
import BlogPostClient from "@/app/(public)/blog/[slug]/BlogPostClient";

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  return <BlogPostClient slug={slug!} />;
}
